import { Link, useLocation } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategoryNav() {
  const location = useLocation();

  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2 scrollbar-hide flex-wrap">
      {categories.map((cat) => (
        <Link
          key={cat.slug}
          to={`/category/${cat.slug}`}
          className={`flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all duration-300 ${
            location.pathname === `/category/${cat.slug}`
              ? "bg-primary-500 text-white"
              : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
          }`}
        >
          <i className={`${cat.icon} text-base`}></i>
          {cat.name}
          <span className="text-xs opacity-70">{cat.count}+</span>
        </Link>
      ))}
    </div>
  );
}